export default "__VITE_ASSET__w$lmWkBM__"